/* eslint-disable */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Switch from '@mui/material/Switch';
import Wrapper from '../components/Wrapper';
import templatePlaceholder from '../../../../assets/img/permits/template_placeholder.png';
import { ConfirmAlert } from 'modules/common/components/Alert';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import * as actions from '../../cms/action';
import * as c from '../../cms/constant';
import { getType, getManagePermission } from '../helper';

const Permit = ({ getList, item, history, update, match, deleteTemplate }) => {
  const permit = _.get(match, 'params.permit', '');
  const [active, setActive] = useState(1);
  const permitList = JSON.parse(_.get(item, '0.attributes.body') || '[]');
  const permissions = getJson('permissions');
  const canManage = Acl(permissions, [getManagePermission(permit)]);

  useEffect(() => {
    if (permit) {
      getList({ type: getType(permit) });
    }
  }, [permit]);

  useEffect(() => {
    if (item) {
      // Check if permitList is an array
      if (Array.isArray(permitList)) {
        const defaultIndex = permitList.findIndex((permit) => permit.selected);
        setActive(defaultIndex);
      } else {
        console.error('permitList is not an array:', permitList);
        setActive(-1); // or some default value
      }
    }
  }, [item]);

  const handleDelete = (index) => {
    const cmsId = _.get(item, '0.id', 0);

    ConfirmAlert(
      'Are you sure, you want to remove this template?',
      () => {
        deleteTemplate(cmsId, index, () => {
          getList({ type: getType(permit) });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <Wrapper>
      <div
        style={{
          overflowY: 'auto',
          position: 'relative',
        }}
      >
        <div
          style={{
            height: '100%',
            display: 'grid',
            gap: '10px',
            gridTemplateColumns: 'repeat(3, minmax(0, 1fr)',
          }}
        >
          {Array.from(
            JSON.parse(_.get(item, '0.attributes.body') || '[]'),
            (data, i) => (
              <div
                className="border rounded bg-white d-flex flex-column"
                key={i}
              >
                <div
                  className="d-flex align-items-center justify-content-between gap-2 card-header bg-light"
                  style={{ gap: '10px' }}
                >
                  <Switch
                    checked={active === i}
                    onChange={() => {
                      setActive(i);

                      let obj = JSON.parse(
                        _.get(item, '0.attributes.body') || '[]'
                      );

                      obj = obj.map((template, index) => ({
                        ...template,
                        selected: index === i,
                      }));

                      if (_.get(item, '0.id')) {
                        update(
                          _.get(item, '0.id'),
                          {
                            // type: getType(permit),
                            body: JSON.stringify(obj),
                          },
                          () => {
                            history.push(
                              `/general-settings/templates/${permit}`
                            );
                          }
                        );
                      }
                    }}
                    className="ml-n2"
                  />
                  <h5 className="m-0">SELECT AS DEFAULT</h5>
                </div>

                <div className="card-body d-flex align-items-center justify-content-center flex-grow-1">
                  <img
                    src={
                      data.placeholderImg == ''
                        ? templatePlaceholder
                        : data.placeholderImg
                    }
                    alt="Template"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      objectFit: 'contain',
                    }}
                  />
                </div>

                {/* {active === i ? ( */}
                <div className="card-footer bg-light d-flex justify-items-between">
                  {active !== i && canManage && (
                    <button
                      type="button"
                      className="btn-blank p-1 text-danger"
                      onClick={() => handleDelete(i)}
                    >
                      <i className="far fa-trash-alt" />
                    </button>
                  )}

                  {canManage && (
                    <button
                      type="button"
                      onClick={() => {
                        history.push(
                          `/general-settings/templates/${permit}/update/${i}`
                        );
                      }}
                      className="btn btn-sm bg-primary text-white ml-auto"
                    >
                      Customize Template
                    </button>
                  )}
                </div>
                {/* ) : null} */}
              </div>
            )
          )}
        </div>
      </div>
    </Wrapper>
  );
};

Permit.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: _.get(api, `${c.GET_SETTINGS}.list`) || [] || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(Permit);
